// extracted by mini-css-extract-plugin
export default {"container":"b4-z","list":"c4-z"};